import {APIDefinitionSpec, APIDataSpec, defineEndpoint} from '../API';

export const enum AuthAPI {
    CONFIRM_PASSWORD = 'AUTH_CONFIRM_PASSWORD',
    FORGOT_PASSWORD = 'AUTH_FORGOT_PASSWORD',
    LOGIN = 'AUTH_LOGIN',
    LOGOUT = 'AUTH_LOGOUT',
    NEW_PASSWORD = 'AUTH_NEW_PASSWORD',
}

export const AuthData: APIDataSpec<typeof AuthAPI> = {
    CONFIRM_PASSWORD: defineEndpoint(AuthAPI.CONFIRM_PASSWORD, 'api/auth/password/confirm'),
    FORGOT_PASSWORD: defineEndpoint(AuthAPI.FORGOT_PASSWORD, 'api/auth/password/forgot'),
    LOGIN: defineEndpoint(AuthAPI.LOGIN, 'api/auth/login'),
    LOGOUT: defineEndpoint(AuthAPI.LOGOUT, 'api/auth/logout'),
    NEW_PASSWORD: defineEndpoint(AuthAPI.NEW_PASSWORD, 'api/auth/password/new')
};
export interface AuthTypes extends APIDefinitionSpec<AuthAPI> {
    [AuthAPI.CONFIRM_PASSWORD]: {
        GET: [void, void];
    };
    [AuthAPI.FORGOT_PASSWORD]: {
        GET: [void, void];
    };
    [AuthAPI.LOGIN]: {
        GET: [void, void];
    };
    [AuthAPI.LOGOUT]: {
        POST: [void, void, void];
    };
    [AuthAPI.NEW_PASSWORD]: {
        GET: [void, void];
    };
}
